<div class="report-heading d-flex align-items-center justify-content-between pr-4 pl-4">

  <h2 class="detail-heading"> {{ chartTitle | translate }} <span *ngIf="minDateOnwards">({{ minDateOnwards }})</span></h2>

    <app-dropdown-checkbox-project *ngIf="trendsDropdown.length"
     [dropDownOption]="trendsDropdown"
     (dropDownValue)="trendsdropDownChange($event)"
     [selected_item]="selected_item"
     [dropdownTitle]="dropdownLabel"
     [showInvalueText]="false">
    </app-dropdown-checkbox-project>
</div>

<div class="main-card-details" *ngIf="chartOverviewData?.length">
  <ul>
    <li *ngFor="let item of chartOverviewData">
      <span class="overview-title">{{ item.label | translate }}</span>
      <ng-container *ngIf="item.label === 'reports.DateRange'; else otherValues">
        <span class="overview-value date-sec" *ngIf="item.value; else nodate">
          <span>{{ item.value.split('to')[0] }}</span>
          <span class="date-separator">to</span>
          <span>{{ item.value.split('to')[1] }}</span>
        </span>
        <ng-template #nodate>{{'-'}}</ng-template>
      </ng-container>

      <ng-template #otherValues>
        <span class="overview-value" *ngIf="item.value?.text; else plainValue">
          {{ item.value.text | number : '1.0-1' }}
          <span class="symbol">{{ item.value.symbol }}</span>
        </span>
        <ng-template #plainValue>
          <span class="overview-value">{{'-'}}</span>
        </ng-template>
      </ng-template>
    </li>
  </ul>
</div>

<ng-container *ngIf="priceChartData?.length && !chartLoader">
  <app-report-charts [height]="'350px'"
   [chartType]="chartView.analysisChart"
   [isBorder]="false" [name]="chartId"
   [staticZoning]="false"
   [data]="priceChartData"
   [label]="selectedChartId+(sqmLabel?' sqm':'')">
  </app-report-charts>
</ng-container>

<div class="no-chart-data" *ngIf="!priceChartData?.length && !chartLoader">
  <strong>{{'no_data_chart_message1' | translate}}</strong>
  <div class="message">
      <p>{{'no_data_chart_message2' | translate}}</p>
      <p>{{'no_data_chart_message3' | translate}}</p>
  </div>
</div>
<div *ngIf="chartLoader">
  <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
</div>